import { getMediaLabel } from './reviewGallery';

import { DEFAULT_REVIEWER_NAME, IMAGE, VIDEO } from 'constants/appConstants';

function mapAndFilter(arr, mapFn, filterFn) {
  const output = [];
  arr.forEach((item, i, inputArray) => {
    if (filterFn(item, i, inputArray)) {
      output.push(mapFn(item, i, inputArray));
    }
  });
  return output;
}

const filterUnknownMedia = ({ mediaType }) => mediaType === IMAGE || mediaType === VIDEO;
const makeMediaMapper = review => reviewMedia => {
  const authorByline = getReviewAuthorByline(review);
  const label = getMediaLabel(reviewMedia.mediaType, authorByline);
  return ({ ...reviewMedia, authorByline, label });
};
export const getReviewAuthorByline = review => `${review.name || DEFAULT_REVIEWER_NAME}${review.powerReview ? '' : ', Zappos Customer'}`;

export function cleanReview(review) {
  if (!review || !review.summary) {
    return review;
  }
  // strip out \r's until a new version of 16+ is released
  // see https://github.com/facebook/react/issues/11103
  // Should we be styling newlines something differently here so that newlines are preserved in output?
  let filteredMedia = review.reviewGalleryMedia;
  if (review.hasMedia && review.reviewGalleryMedia) {
    const mapper = makeMediaMapper(review);
    filteredMedia = mapAndFilter(review.reviewGalleryMedia, mapper, filterUnknownMedia);
  }
  return {
    ...review,
    summary: review.summary.replace(/\r\n/g, '\n'),
    reviewGalleryMedia: filteredMedia,
    authorByline: getReviewAuthorByline(review)
  };

}
/**
 * [cleanReviews description]
 * @param  {Array} reviews
 * @return {Array}         Reviews list with summary text cleaned of newlines.
 */
export default function cleanReviews(reviews) {
  return reviews ? reviews.map(cleanReview) : reviews;
}
